"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApolloClient = void 0;
const crypto_hash_1 = require("crypto-hash");
const client_1 = require("@apollo/client");
const error_1 = require("@apollo/client/link/error");
const persisted_queries_1 = require("@apollo/client/link/persisted-queries");
const apollo_upload_client_1 = require("apollo-upload-client");
const apollo_fetch_1 = require("./apollo-fetch");
const interfaces_1 = require("../interfaces");
/**
 * apollo link config
 * @param request - Pass in a request func that sets the context of operation
 * */
const requestLink = (request) => {
    return new client_1.ApolloLink((operation, forward) => new client_1.Observable(observer => {
        let handle;
        Promise.resolve(operation)
            .then((op) => request.apply(null, [op]))
            .then(() => {
            handle = forward(operation).subscribe({
                next: observer.next.bind(observer),
                error: observer.error.bind(observer),
                complete: observer.complete.bind(observer),
            });
        })
            .catch(observer.error.bind(observer));
        return () => {
            if (handle)
                handle.unsubscribe();
        };
    }));
};
/**
 * Common apollo client configuration for both user and admin
 * @param cache - The InMemoryCache defined with possible types
 * @param apolloErrorHandler - Apollo error handler function
 * @param request - Request function where the operation context need to be set
 * @param serverUri - Backend server uri
 * */
exports.createApolloClient = (cache, apolloErrorHandler, request, serverUri) => {
    return new client_1.ApolloClient({
        cache,
        link: client_1.ApolloLink.from([
            error_1.onError((errorResponse) => {
                apolloErrorHandler.apply(null, [errorResponse]);
            }),
            requestLink(request),
            persisted_queries_1.createPersistedQueryLink({ sha256: crypto_hash_1.sha256 }),
            client_1.ApolloLink.split(operation => operation.getContext().clientName === interfaces_1.CLIENT_TYPE.SCOUT_BACKEND, apollo_upload_client_1.createUploadLink({
                uri: `${process.env.REACT_APP_SCOUT_BACKEND_URL}/api`,
                fetch: apollo_fetch_1.customFetch,
            }), apollo_upload_client_1.createUploadLink({
                uri: serverUri,
                fetch: apollo_fetch_1.customFetch,
            })),
        ]),
    });
};
//# sourceMappingURL=data:application/json;base64,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